/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import qs from 'query-string';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'sonner';

const SingleSignOn = () => {
  const { search } = useLocation();
  const { id } = qs.parse(search);
  const [data, setData] = useState();

  const token = atob(id);
  useEffect(() => {
    const fetchData = async () => {
      if (!token) {
        return;
      }

      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/accounts/auth/user/`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        const result = await response.json();
        setData(result);
      } catch (error) {
        toast.error('Error fetching data:', error);
      }
    };

    fetchData();
  }, [token]);

  useEffect(() => {
    if (data?.email) {
      localStorage.setItem('user', JSON.stringify(data));
      localStorage.setItem('access_token', atob(id));
      localStorage.setItem(
        'business_domain',
        data?.business_user_memberships[0]?.business_id
      );
      window.location.href = '/dashboard';
    }
  }, [data, id]);

  return (
    <div className='w-screen h-screen flex justify-center items-center'>
      <img
        width={250}
        height={250}
        alt='loading spinner'
        src='https://res.cloudinary.com/dgny8sjrg/image/upload/v1638526892/Bizedge_Frontend_Assets/BizLoader_dzmb4i.gif'
      />
    </div>
  );
};

export default SingleSignOn;
